import styled from "styled-components";
import {
  ICON_COLORS,
  LAYER_COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";
import { FONT_CSS } from "../../constants/design/fontSize";
import {
  BORDER_RADIUS,
  COMPONENTS,
  SPACING,
} from "../../constants/design/spacing";

export const HeaderText = styled.p`
  margin: 0;
  line-height: 1.2;
  ${FONT_CSS.header.seven};
  color: ${TEXT_COLORS.one};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const SubText = styled.p`
  ${FONT_CSS.label.two}
  margin: 0;
  margin-top: 2px;
  line-height: 1.2;
  color: ${TEXT_COLORS.three};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const ClearButton = styled.button`
  opacity: 0.4;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CommandKeyChevronContainer = styled.div`
  display: flex;

  > div {
    min-width: 24px;
    min-height: 24px;
    border-radius: ${BORDER_RADIUS.two}px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: ${SPACING.one}px;

    ${FONT_CSS.body.five}
    background-color: ${LAYER_COLORS.two};
    color: ${TEXT_COLORS.three};

    span {
      padding: ${SPACING.one}px ${SPACING.two}px;
    }

    svg {
      stroke: ${ICON_COLORS.three};
    }
  }
`;

export const MarketsDropdownWrapper = styled.button`
  border-radius: ${BORDER_RADIUS.five}px;
  text-align: left;
  display: flex;
  width: 100%;
  min-width: 0;
  height: ${COMPONENTS.header.sub}px;
  background-color: ${LAYER_COLORS.one};
  justify-content: space-between;

  > * {
    margin: auto ${SPACING.one}px;
    display: flex;
    align-items: center;
    min-width: 0;

    &:last-child {
      margin-right: ${SPACING.two}px;
    }
  }

  /* Left side: logo + text block. Allow shrinking so the text block can
     truncate with ellipsis instead of wrapping to two lines. The right
     padding keeps the text from kissing the CTRL+K / chevron group. */
  > div:first-child {
    flex: 1;
    min-width: 0;
    padding-left: ${SPACING.two}px;
    padding-right: ${SPACING.three}px;
  }

  /* Inner text column (HeaderText + SubText) needs min-width: 0 so the
     text-overflow: ellipsis on its children can actually fire. Vertical
     centering + small gap between title and subtitle gives breathing room. */
  > div:first-child > div {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
  }

  > div > img,
  > div > span:first-child {
    margin-right: ${SPACING.two}px;
    flex-shrink: 0;
  }

  &:hover {
    ${CommandKeyChevronContainer} {
      > * {
        transition: all 0.2s ease-out;
        color: ${TEXT_COLORS.one};
      }
      svg {
        transition: all 0.2s ease-out;
        stroke: ${TEXT_COLORS.one};
        opacity: 1;
      }
    }
  }
`;
